import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {
    type OttopilotEvent,
    ottopilotEventValidator,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventsWorkspaceCapability/domain/OttopilotEvent";
import {z as zod} from "zod";

export type OttopilotEventContainer = {
    additionalColumnValues: Record<Uuid, unknown>;
    createdAt: Iso8601DateTime;
    createdBy: Uuid;
    id: Uuid;
    notes?: unknown;
    revisionId: Uuid;
    status: OttopilotEventContainerStatus;
    templateId: Uuid;
    updatedAt: Iso8601DateTime;
    updatedBy: Uuid;
};

export enum OttopilotEventContainerStatus {
    active = "383c5aaa-3ee3-472b-b756-be168447a46c",
    archived = "3b29eb52-0f58-44ab-843f-5dcbc4584ebb",
}

export const ottopilotEventContainerValidator = zod.strictObject({
    additionalColumnValues: zod.record(uuidZodValidator, zod.unknown()),
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    id: uuidZodValidator,
    notes: zod.unknown().optional(),
    revisionId: uuidZodValidator,
    status: zod.enum(OttopilotEventContainerStatus),
    templateId: uuidZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
}) satisfies zod.ZodType<OttopilotEventContainer>;

export type OttopilotEventContainerCudLog = OttopilotEventContainer;

export const ottopilotEventContainerCudLogValidator: zod.ZodType<OttopilotEventContainerCudLog> =
    ottopilotEventContainerValidator;

export type OttopilotEventContainerWithEvents = OttopilotEventContainer & {
    events: Array<OttopilotEvent>;
};

export const ottopilotEventContainerWithEventsValidator = ottopilotEventContainerValidator.extend({
    events: ottopilotEventValidator.array(),
}) satisfies zod.ZodType<OttopilotEventContainerWithEvents>;
